import React, { useEffect, useState, useMemo } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useErrorHandler } from "../../../hooks";

import advertisementService from "../../../services/advertisement.service";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function AdsTable(props) {

    const { categories } = props;

    const errorHandler = useErrorHandler();

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await advertisementService.deleteAdvertisement(item.id);
        if (res.error) {
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "index",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "categoryTitle",
                title: "صفحه",
                mainField: true,
            },
            {
                field: "showInRow",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "image",
                title: "عکس",
                renderer: (val) =>
                    val ? <img className="main-page-img" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    const onRefresh = async () => {
        const { data, error } = await advertisementService.getAdvertisement();
        if (error) {
            return;
        }

        const rows = data
            .map(item => {
                item.categoryTitle = categories.find(it => it.value === item.category)?.title;
                return item;
            })
            .sort((a, b) => a.index - b.index)

        setData(rows);
    };

    useEffect(() => {
        onRefresh();
    }, []);

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                order={{ order: "ASC", orderBy: "index" }}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => <FormModalContent {...props} hasMoreButton={true} type="fullCard" />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد تبلیغ",
                        modalContent: (props) => <FormModalContent {...props} hasMoreButton={true} type="fullCard" />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="تبلیغ ها"
            />
        </div>
    );
}
